import React, { useState, useEffect } from "react";
import {
  Stack,
  Paper,
  TextField,
  Autocomplete,
  Box,
  Button,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { context_styles } from "../context_builder_dark_styles";
import { Projects } from "../context_components/projects";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { contextBuilderActions } from "../../store/store";
import { alpha, styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSpring, animated } from "@react-spring/web";
import { Chip } from "@mui/material";
import Pagination from "@mui/material/Pagination";

export default function QaAnalysis() {
  const dispatch = useDispatch();
  const [mappingData, setMappingData] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [questionId, setQuestionId] = useState([]);
  const [filteredCustomerAnswers, setFilteredCustomerAnswers] = useState([]);
  const [validateAnswerFilter, setValidateAnswerFilter] = useState([]);
  const [selectedQuestionId, setSelectedQuestionId] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [selectedQuestionTypes, setSelectedQuestionTypes] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedPage, setSelectedPage] = useState(0);
  const [editData, setEditData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const { projectInfo, projects } = useSelector(
    (state) => state.projectInfoStore
  );
  const { col_100 } = useSelector((state) => state.themeStore);

  const config = projects.filter(
    (r) => r.country === projectInfo[0] && r.env === projectInfo[1]
  )[0];

  const { auditResults } = useSelector((state) => state.sosSodStore);
  console.log(auditResults,"48")

  let customerAnswers;
  if (auditResults && auditResults[0].customerAnswer) {
    customerAnswers = auditResults[0].customerAnswer;
  }

  const validateAnswer = auditResults[0].validateAnswer
    ? auditResults[0].validateAnswer
    : auditResults[0].customerAnswer;

  useEffect(() => {
    const validateFilter = Object.entries(validateAnswer).map(
      ([questionId, [answer, question]]) => {
        const mappedQuestion = mappingData.find((map) => map[3] === questionId);
        const questionType = mappedQuestion ? mappedQuestion[1] : "-";
        return {
          questionId,
          answer,
          question,
          questionType,
        };
      }
    );
    // .filter((item) => item.questionType !== "");
    setValidateAnswerFilter(validateFilter);
  }, [customerAnswers, mappingData, validateAnswer]);

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0,
    },
    config: {
      mass: 7,
    },
  }));

  useEffect(() => {
    api.start({
      from: {
        y: -15 + "%",
      },
      to: {
        y: 0 + "%",
      },
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let apiUrl = "";

        if (config && config.projectName === "ira-india") {
          apiUrl = "/get_context/get_ircp_mapping";
        } else if (config && config.projectName === "opti_live1") {
          apiUrl = "/get_context/get_mapping";
        }

        if (apiUrl) {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (response.ok) {
            const jsonData = await response.json();
            setMappingData(jsonData);
            const uniqueTypes = Array.from(
              new Set(jsonData.map((item) => item[1]))
            ).filter((type) => type !== "question_type");
            setQuestionTypes(uniqueTypes);
          } else {
            console.error("Error fetching mapping data:", response.statusText);
          }
        } else {
          console.error(
            "Invalid projectName:",
            config ? config.projectName : "No config found"
          );
        }
      } catch (error) {
        console.error("Error fetching mapping data:", error);
      }
    };

    fetchData();
  }, [config]);

  useEffect(() => {
    const filteredData = Object.entries(customerAnswers).map(
      ([questionId, [answer, question]]) => {
        const mappedQuestion = mappingData.find((map) => map[3] === questionId);
        const questionType = mappedQuestion ? mappedQuestion[1] : "";
        const clientRequired = mappedQuestion ? mappedQuestion[2] : "";
        return {
          questionId,
          answer,
          question,
          questionType,
          clientRequired,
        };
      }
    );
    // .filter((item) => item.questionType !== "");
    setFilteredCustomerAnswers(filteredData);
  }, [customerAnswers, mappingData]);

  const selectedQuestionData = filteredCustomerAnswers.filter((item) =>
    selectedQuestionTypes.includes(item.questionType)
  );

  useEffect(() => {
    const questionIds = selectedQuestionData.map((item) => item.questionId);
    setQuestionId(questionIds);
  }, [questionTypes, selectedQuestionTypes]);

  const handleQuestionIdChange = (event, value) => {
    setSelectedQuestionId(value);
    const data = selectedQuestionData.filter((item) => {
      return value === item.questionId;
    });
    setFinalData(data);
  };

  const handlePageChange = () => {
    dispatch(contextBuilderActions.changePage("default"));
  };

  const handleQuestionTypeChange = (event, values) => {
    const updatedValues = Array.isArray(values) ? values : [];
    setSelectedQuestionTypes(updatedValues);
  };

  const handleHIAnswer = (id, question, answer) => {
    const isNumber = !isNaN(answer);

    setEditData((prevAnswers) => ({
      ...prevAnswers,
      [id]: {
        answer: isNumber ? Number(answer) : answer,
        question: question,
      },
    }));

    const updatedData = validateAnswerFilter.map((item) => {
      if (item.questionId === id) {
        if (item.answer !== answer) {
          return { ...item, answer };
        }
      }
      return item;
    });

    setValidateAnswerFilter(updatedData);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSave = async () => {
    if (Object.keys(editData).length > 0) {
      const updatedAnswersWithAuditID = filteredCustomerAnswers
        .filter((item) => editData[item.questionId] !== undefined)
        .map((item) => {
          const updatedAnswer = editData[item.questionId];
          return {
            ...item,
            answer: updatedAnswer.answer,
            auditID: auditResults[0].AuditID,
            activeProjectIC: config.tag,
          };
        });

      try {
        const response = await fetch("/get_context/save_answers", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ key: updatedAnswersWithAuditID }),
        });

        if (response.ok) {
          console.log("Answers saved successfully");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setEditData({});
        } else {
          console.error("Error saving answers:", response.statusText);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error saving answers:", error);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } else {
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
    }

    // const updatedData = validateAnswerFilter.map((item) => {
    //   if (item.questionId === id) {
    //     if (item.answer !== answer) {
    //       return { ...item, answer };
    //     }
    //   }
    //   return item;
    // });

    // setValidateAnswerFilter(updatedData);
  };

  const list_styles = {
    display: "flex",
    justifyContent: "center",
    maxHeight: "52vh",
    minHeight: "fit-content",
    width: "16.5rem",
  };

  const StyledChip = styled(Chip)(({ theme }) => ({
    backgroundColor: col_100,
    color: "rgba(245, 245, 245, 0.75)",
  }));

  const paginationStyles = {
    "& [class*='MuiPaginationItem-root']": {
      color: "rgba(255, 255, 255, 0.5)",
    },
    "& [class*='MuiButtonBase-root'][class*='MuiPaginationItem-root']": {
      fontSize: "0.75rem",
      width: "12px",
      minWidth: "unset",
      padding: "0px 3px",
    },
    "& [class*='MuiButtonBase-root'][class*='MuiPaginationItem-root'].Mui-selected":
      {
        backgroundColor: "rgba(32, 38, 43, 0.95)",
      },
  };

  const renderSelectedOptions = (selectedOptions) => {
    let displayedOptions = selectedOptions.slice(0, 0);

    if (selectedOptions.length > 0) {
      const remainingCount = selectedOptions.length;
      const remainingOptions = `+${remainingCount}`;
      displayedOptions = displayedOptions.concat(remainingOptions);
    }

    return (
      <div>
        {displayedOptions.map((option, index) => (
          <StyledChip
            size="small"
            key={index}
            label={option}
            onDelete={() => handleQuestionTypeChange(option, "")}
          />
        ))}
      </div>
    );
  };

  const questionsPerPage = 1;
  const indexOfLastQuestion = (currentPage + 1) * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentQuestionBasedOnType =
    finalData.length > 0
      ? finalData.slice(indexOfFirstQuestion, indexOfLastQuestion)
      : selectedQuestionData.slice(indexOfFirstQuestion, indexOfLastQuestion);
  const currentQuestions = filteredCustomerAnswers.slice(
    indexOfFirstQuestion,
    indexOfLastQuestion
  );

  const handleKeyDown = (event) => {
    if (event.keyCode === 37) {
      setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleKeyUp = (event) => {
    if (event.keyCode === 39) {
      setCurrentPage((prevPage) => {
        let nextLength;
        if (selectedQuestionData.length > 0) {
          nextLength =
            finalData.length > 0
              ? finalData.length
              : selectedQuestionData.length;
        } else {
          nextLength = filteredCustomerAnswers.length;
        }

        const nextPage =
          nextLength > 0
            ? Math.min(
                prevPage + 1,
                Math.ceil(nextLength / questionsPerPage) - 1
              )
            : 0;

        return nextPage;
      });
    }
  };

  // useEffect(() => {
  //   setSelectedPage(currentPage);
  //   document.addEventListener("keydown", handleKeyDown);
  //   document.addEventListener("keyup", handleKeyUp);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //     document.removeEventListener("keyup", handleKeyUp);
  //   };
  // }, [currentPage, handleKeyUp]);

  const totalPages = Math.ceil(
    finalData.length > 0
      ? finalData.length / questionsPerPage
      : selectedQuestionData.length / questionsPerPage
  );

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
  };

  const totalPages1 = Math.ceil(
    filteredCustomerAnswers.length / questionsPerPage
  );

  const handlePreviousPage1 = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const handleNextPage1 = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages1 - 1));
  };

  useEffect(() => {
    setSelectedPage(currentPage);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [currentPage, handleKeyUp]);

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={5} sx={context_styles}>
        <Stack className="brand-analysis" spacing={0} sx={{ p: 1 }}>
          <Stack direction="row" className="page-header-dark">
            <ChevronLeftIcon className="left-dark" onClick={handlePageChange} />
            <span style={{ fontSize: "0.9rem" }}>QA Analysis</span>
            <div className="right-dark"></div>
          </Stack>
          <div style={list_styles} className="context-scroll-dark">
            <Stack
              direction="column"
              spacing={2}
              style={{ /*height: "50vh", */ width: "86%", marginTop: "0.4rem" }}
            >
              <Autocomplete
                multiple
                options={questionTypes}
                value={selectedQuestionTypes}
                onChange={handleQuestionTypeChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Question Type`}
                    InputLabelProps={{
                      style: { color: "rgba(255, 255, 255, 0.5)" },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      style: { color: "rgba(255, 255, 255, 0.5)" },
                    }}
                    sx={{
                      backgroundColor: "rgba(32, 38, 43, 0.95)",
                      borderRadius: "10px",
                    }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  renderSelectedOptions(value)
                }
                sx={{
                  "& .MuiAutocomplete-endAdornment .MuiIconButton-root": {
                    color: "rgba(255, 255, 255, 0.5)",
                  },
                }}
              />
              {selectedQuestionTypes.length > 0 ? (
                <Autocomplete
                  options={questionId}
                  value={selectedQuestionId}
                  onChange={handleQuestionIdChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Question Id"
                      InputLabelProps={{
                        style: { color: "rgba(255, 255, 255, 0.5)" },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        style: { color: "rgba(255, 255, 255, 0.5)" },
                      }}
                      sx={{
                        backgroundColor: "rgba(32, 38, 43, 0.95)",
                        borderRadius: "10px",
                      }}
                    />
                  )}
                  sx={{
                    "& .MuiAutocomplete-endAdornment .MuiIconButton-root": {
                      color: "rgba(255, 255, 255, 0.5)",
                    },
                  }}
                />
              ) : (
                <></>
              )}
            </Stack>
          </div>
          <Box
            sx={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "0.9rem",
                  color: "rgba(255, 255, 255, 0.5)",
                }}
              >
                Question and Answer
              </span>
            </Box>

            {selectedQuestionTypes.length === 0 ? (
              currentQuestions.map((question, index) => {
                const validateItem = validateAnswerFilter.find(
                  (item) => item.questionId === question.questionId
                );
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      padding: "10px",
                      marginTop: "1rem",
                      height: "200px",
                      minHeight: "fit-content",
                      width: "14.5rem",
                      backgroundColor: "rgba(32, 38, 43, 0.95)",
                      color: "rgba(255, 255, 255, 0.5)",
                      borderRadius: "10px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      transition: "box-shadow 0.3s ease-in-out",
                      "&:hover": {
                        boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
                      },
                    }}
                  >
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box sx={{ marginBottom: "10px" }}>
                        {question.questionId}
                      </Box>
                      <Box sx={{ marginLeft: "auto", marginRight: "35px" }}>
                        {question.questionType}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        width: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "wrap",
                      }}
                    >
                      {question.question}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "1rem",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            color: "rgba(255, 255, 255, 0.5)",
                          }}
                        >
                          AI
                        </Box>

                        <Box sx={{ margin: "25px 5px 0px 0px " }}>
                          <Box>{question.answer}</Box>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            color: "rgba(255, 255, 255, 0.5)",
                            marginRight: "20px",
                          }}
                        >
                          HI
                        </Box>

                        <Tooltip title="Edit Answer" arrow>
                          <Box
                            sx={{ margin: "25px 5px 0px 0px", display: "flex" }}
                          >
                            <div
                              contentEditable
                              onMouseLeave={(e) =>
                                handleHIAnswer(
                                  validateItem.questionId,
                                  validateItem.question,
                                  e.target.innerText
                                )
                              }
                              dangerouslySetInnerHTML={{
                                __html: validateItem.answer,
                              }}
                              style={{
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.5)",
                                width: "30px",
                              }}
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                    </Box>
                  </Box>
                );
              })
            ) : selectedQuestionData.length > 0 ? (
              currentQuestionBasedOnType.map((question, index) => {
                const validateItem = validateAnswerFilter.find(
                  (item) => item.questionId === question.questionId
                );
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      padding: "10px",
                      marginTop: "1rem",
                      height: "200px",
                      minHeight: "fit-content",
                      width: "14.5rem",
                      backgroundColor: "rgba(32, 38, 43, 0.95)",
                      color: "rgba(255, 255, 255, 0.5)",
                      borderRadius: "10px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      transition: "box-shadow 0.3s ease-in-out",
                      "&:hover": {
                        boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
                      },
                    }}
                  >
                    {/* <Box
                      sx={{ display: "flex", justifyContent: "space-around" }}
                    >
                      <Box sx={{ marginBottom: "10px" }}>
                        {question.questionId}
                      </Box>
                      <Box>{question.questionType}</Box>
                    </Box> */}
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box sx={{ marginBottom: "10px" }}>
                        {question.questionId}
                      </Box>
                      <Box sx={{ marginLeft: "auto", marginRight: "35px" }}>
                        {question.questionType}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        width: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "wrap",
                      }}
                    >
                      {question.question}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "1rem",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            color: "rgba(255, 255, 255, 0.5)",
                          }}
                        >
                          AI
                        </Box>

                        <Box sx={{ margin: "25px 5px 0px 0px " }}>
                          <Box>{question.answer}</Box>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            color: "rgba(255, 255, 255, 0.5)",
                            marginRight: "20px",
                          }}
                        >
                          HI
                        </Box>

                        <Tooltip title="Edit Answer" arrow>
                          <Box sx={{ margin: "25px 5px 0px 0px" }}>
                            <div
                              contentEditable
                              onMouseLeave={(e) =>
                                handleHIAnswer(
                                  validateItem.questionId,
                                  validateItem.question,
                                  e.target.innerText
                                )
                              }
                              dangerouslySetInnerHTML={{
                                __html: validateItem.answer,
                              }}
                              style={{
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.5)",
                                width: "30px",
                              }}
                            />
                          </Box>
                        </Tooltip>
                      </Box>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  padding: "10px",
                  marginTop: "1rem",
                  height: "150px",
                  minHeight: "fit-content",
                  width: "14.5rem",
                  backgroundColor: "rgba(32, 38, 43, 0.95)",
                  color: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "10px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  transition: "box-shadow 0.3s ease-in-out",
                  "&:hover": {
                    boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  No Answer
                </Box>
              </Box>
            )}

            {selectedQuestionTypes.length > 0 ? (
              <Box
                sx={{
                  marginTop: "1rem",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                {selectedQuestionData.length === 0 ? (
                  <>
                    <Box>
                      <span
                        style={{
                          color: "rgba(255, 255, 255, 0.5)",
                          marginRight: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {"<"}
                      </span>
                      <span style={{ color: "rgba(255, 255, 255, 0.5)" }}>
                        {`${currentPage === 0 ? 0 : currentPage + 1} / ${
                          totalPages === 0 ? 0 : totalPages
                        }`}
                      </span>
                      <span
                        style={{
                          color: "rgba(255, 255, 255, 0.5)",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {">"}
                      </span>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box sx={{ marginRight: "20px" }}>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "rgba(245, 245, 245, 0.75)",
                          color: "rgba(32, 38, 43, 0.95)",
                          "&.MuiButton-contained": {
                            minWidth: "unset",
                            width: "60px",
                            padding: "5px 15px",
                          },
                          "&:hover": {
                            backgroundColor: alpha(
                              "rgba(255, 255, 255, 0.1)",
                              0.2
                            ),
                          },
                        }}
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                    </Box>
                    <Box>
                      <span
                        style={{
                          color: "rgba(255, 255, 255, 0.5)",
                          marginRight: "10px",
                          cursor: "pointer",
                        }}
                        onClick={handlePreviousPage}
                        tabIndex={0}
                      >
                        {"<"}
                      </span>
                      <span style={{ color: "rgba(255, 255, 255, 0.5)" }}>
                        {` ${currentPage + 1} / ${totalPages}`}
                      </span>
                      <span
                        style={{
                          color: "rgba(255, 255, 255, 0.5)",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={handleNextPage}
                        tabIndex={0}
                      >
                        {">"}
                      </span>
                    </Box>
                  </>
                )}
              </Box>
            ) : (
              <Box
                sx={{
                  marginTop: "1rem",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "rgba(245, 245, 245, 0.75)",
                      color: "rgba(32, 38, 43, 0.95)",
                      "&.MuiButton-contained": {
                        minWidth: "unset",
                        width: "60px",
                        padding: "5px 15px",
                      },
                      "&:hover": {
                        backgroundColor: alpha("rgba(255, 255, 255, 0.1)", 0.2),
                      },
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </Box>
                <Box>
                  <span
                    style={{
                      color: "rgba(255, 255, 255, 0.5)",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                    onClick={handlePreviousPage1}
                    tabIndex={0}
                  >
                    {"<"}
                  </span>
                  <span style={{ color: "rgba(255, 255, 255, 0.5)" }}>
                    {` ${currentPage + 1} / ${totalPages1}`}
                  </span>
                  <span
                    style={{
                      color: "rgba(255, 255, 255, 0.5)",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                    onClick={handleNextPage1}
                    tabIndex={0}
                  >
                    {">"}
                  </span>
                </Box>
              </Box>
            )}

            {/* <Box
              sx={{
                marginTop: "1rem",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectedQuestionData.length > 0 ? (
                <Pagination
                  count={Math.ceil(
                    finalData.length > 0
                      ? finalData.length / questionsPerPage
                      : selectedQuestionData.length / questionsPerPage
                  )}
                  color="primary"
                  page={selectedPage + 1}
                  onChange={(event, value) => setCurrentPage(value - 1)}
                  sx={paginationStyles}
                  // sx={{
                  //   "& .MuiPaginationItem-root": {
                  //     color: "rgba(255, 255, 255, 0.5)",
                  //   },
                  //   "& .css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root":
                  //     {
                  //       fontSize: "0.75rem",
                  //       width: "12px",
                  //       minWidth: "unset",
                  //     },
                  //   "& .css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected":
                  //     {
                  //       backgroundColor: "rgba(32, 38, 43, 0.95)",
                  //     },
                  // }}
                />
              ) : selectedQuestionTypes.length > 0 &&
                selectedQuestionData.length === 0 ? (
                <Pagination
                  count={1}
                  color="primary"
                  page={selectedPage + 1}
                  onChange={(_event, value) => setCurrentPage(0)}
                  sx={paginationStyles}
                />
              ) : (
                <Pagination
                  count={Math.ceil(
                    filteredCustomerAnswers.length / questionsPerPage
                  )}
                  color="primary"
                  page={selectedPage + 1}
                  onChange={(event, value) => setCurrentPage(value - 1)}
                  sx={paginationStyles}
                />
              )}

              <Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "rgba(245, 245, 245, 0.75)",
                    color: "rgba(32, 38, 43, 0.95)",
                    "&.MuiButton-contained": {
                      minWidth: "unset",
                      width: "45px",
                      padding: "3px 13px",
                    },
                    "&:hover": {
                      backgroundColor: alpha("rgba(255, 255, 255, 0.1)", 0.2),
                    },
                  }}
                  onClick={handleSave}
                >
                  Save
                </Button>
              </Box>
            </Box> */}
          </Box>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              severity={snackbarSeverity}
              onClose={handleCloseSnackbar}
            >
              {snackbarSeverity === "success"
                ? "Saving is successful"
                : snackbarSeverity === "error"
                ? "Saving failed"
                : "No changes made to data"}
            </MuiAlert>
          </Snackbar>
        </Stack>
        <Projects />
      </Paper>
    </animated.div>
  );
}
